import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'pf-dropdown',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DropdownComponent {
  @Input() label?: string;
  @Input() name: string = 'name';
  @Input() placeholder: string = 'bitte auswählen';
  @Input() options: { label: string; value: string }[] = [];
  @Input() value: string | null = null;
  @Input() required = true;

  @Output() valueChange = new EventEmitter<string | null>();

  onChange(event: Event) {
    const selectEl = event.target as HTMLSelectElement;
    const next = selectEl.value === '' ? null : selectEl.value;
    this.valueChange.emit(next);
  }
}
